import { Injectable } from '@angular/core';
import {DaoGeneric} from '@Services/base/daoService';
import {environment} from '@Env/environment';
import {HttpClient} from '@angular/common/http';
import {Campagne} from './campagne.model';

@Injectable({
  providedIn: 'root'
})
export class CampagneService extends DaoGeneric<Campagne> {

  readonly url = `${environment.baseUrl}/suaps/campagne/`;

  constructor(private httpClient: HttpClient) {
    super(httpClient);
  }
  getRootUrl(): string {
    return this.url;
  }
}
